module.exports = __webpack_public_path__ + "static/media/snake-project.79ea522e.png";